<template>
  <div
    :class="inline ? 'owal form inline field' : 'owal form field'"
  >
    <!-- Add a label for fields that have one. -->
    <label
      v-if="label"
      class="owal form field label"
    >
      {{ label }}
    </label>
    <div
      v-if="multiselect"
      class="owal checkboxes container"
    >
      <label
        v-if="columnsFromOptions.length > 1"
        class="owal-checkbox__container"
      >
        <input
          type="checkbox"
          label="Select All"
          name="selectAll"
          class="owal checkbox input"
          :inputValue="allOptionsAreChecked ? 'checked' : ''"
          :checked="allOptionsAreChecked"
          @change="toggleAll"
        >
        <span
          class="owal-checkbox__label"
        >
          Select All
        </span>
      </label>
      <div
        v-for="(column, index) in columnsFromOptions"
        :key="index"
        :class="`owal checkboxes ${renderingDirection}`"
      >
        <label
          v-for="option in column"
          :key="option.value"
          class="owal-checkbox__container"
        >
          <input
            type="checkbox"
            class="owal checkbox input"
            :checked="optionIsChecked(option)"
            :inputValue="optionIsChecked(option) ? 'checked' : ''"
            :label="option.name"
            @change="setValue(option.value)"
          >
          <span
            class="owal-checkbox__label"
          >
            {{ option.name }}
          </span>
        </label>
      </div>
    </div>
    <!-- Radio style Checkbox (single-select) -->
    <div
      v-else
      class="owal checkboxes container"
    >
      <div
        v-for="(column, index) in columnsFromOptions"
        :key="index"
        :class="`owal checkboxes ${renderingDirection}`"
      >
        <!-- Note the v-for is vue looping and the :for is HTML's label attribute for connecting an input and its label. -->
        <label
          v-for="option in column"
          :key="option.value"
          class="owal radio button"
          :for="option.value"
        >
          <input
            v-if="option.value === initialValue"
            :id="option.value"
            checked
            type="radio"
            class="owal radio input"
            :name="identifier"
            @change="setValue(option.value)"
          >
          <input
            v-else
            :id="option.value"
            type="radio"
            class="owal radio input"
            :name="identifier"
            @change="setValue(option.value)"
          >
          <!--
            Keeping this span here allows us to render fake radio buttons that look nice.
            See: https://www.sitepoint.com/replacing-radio-buttons-without-replacing-radio-buttons/
          -->
          <span>
            {{ option.name }}
          </span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { CollectionInput } from './mixins'

export default {
  name: 'OwalRadioInput',
  mixins: [CollectionInput],
}
</script>

<style scoped>
.owal {
  font-family: 'Lato', 'Avenir';
}

.owal.form.inline.field {
  display: inline-flex;
  flex-direction: column;
  padding: 0.3975rem;
  margin: 0.3975rem;
  box-sizing:border-box;
}

.owal.form.field.label {
  margin-left: 1rem;
  margin-bottom: 0.53rem;
  font-weight: normal;
  font-size: 14px;
  color: #475669;
  letter-spacing: 0;
}

.owal.form.inline.field .owal.text.input {
  width: 25rem;
}

.owal.checkboxes.container {
  display: flex;
  flex-direction: row;
  padding: 1.14rem 0.5rem;
  background: #F3F4F5;
  border: 1px solid #979797;
  border-radius: 8px;
}

.owal.checkboxes.column {
  display: flex;
  flex-direction: column;
}

.owal.checkboxes.row {
  display: flex;
  flex-direction: row;
}

/* Hide radio buttons */
[type="radio"] {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px; margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/* Use the span to redraw fake radios that look nice. */
[type="radio"] + span::before {
  content: '';
  display: inline-block;
  width: 1.31rem;
  height: 1.31rem;
  vertical-align: -0.25rem;
  border-radius: 1em;
  background: #EFF2F7;
  border: 1px solid #979797;
  box-shadow: inset 0 0 0 2px #FFFFFF;
  margin-right: 0.75rem;
  transition: 0.5s ease all;
}

[type="radio"]:checked + span::before {
  background: #475669;
  border: 1px solid #979797;
  box-shadow: inset 0 0 0 2px #FFFFFF;
}

.owal.radio.button {
  font-size: 14px;
  color: #475669;
  height: 1.63rem;
  margin: 0.22rem .66rem;
}

/** Checkbox */
.owal-checkbox__container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: baseline;
  align-items: baseline;
  padding: 0;
  margin: 0;
  flex-grow: 0;
  flex-shrink: 0;
}

.owal-checkbox__label {
  display: inline-flex;
  align-content: center;
  align-items: center;
  justify-content: center;
}

/* Hide checkbox buttons */
[type="checkbox"] {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/* Use the span to redraw fake checkboxes that look nice. */
[type="checkbox"] + span::before {
  content: '';
  display: inline-flex;
  flex-direction: row;
  flex-grow: 0;
  flex-shrink: 0;
  align-content: center;
  align-items: center;
  justify-content: center;
  width: 1.31rem;
  height: 1.31rem;
  vertical-align: -0.25rem;
  border-radius: 0.25em;
  background: #EFF2F7;
  border: 1px solid #979797;
  box-shadow: inset 0 0 0 2px #FFFFFF;
  color: #fff;
  margin-right: 0.35rem;
  margin-left: 0.40rem;
  margin-top: 0.1rem;
  margin-bottom: 0.1rem;
  transition: 0.5s ease all;
  font-size: 1rem;
  padding-top: 1px;
}

[type="checkbox"]:checked + span::before {
  content: '✓';
  color: #475669;
  border: 1px solid #979797;
  box-shadow: inset 0 0 0 2px #FFFFFF;
  transition: 0.5s ease all;
}

</style>
